module.exports = __webpack_public_path__ + "img/pubmed_title.9cc9848b.png";